import { ValueFormHealth, ValueFormHealthAddress } from "../../../../../../constants/health";

interface DefaultData {
    value: string,
    code: string,
}

const DefaultValueFormHealthAddress = (isDisabled: boolean, defaultData?: DefaultData): ValueFormHealthAddress => {
    return {
        value: (defaultData && defaultData.value) || "",
        label: "",
        errorCode: "",
        code: (defaultData && defaultData.code) || "",
        disabled: isDisabled,
    };
}

const DefaultValueFormHealth = (isDisabled: boolean): ValueFormHealth => {
    return {
        value: "",
        errorCode: "",
        disabled: isDisabled,
        code:""
    };
}

export interface AddressDataItem {
    value: string;
    code: string;
    label: string;
}

export interface AddressDataDto {
    address: ValueFormHealthAddress;
    wayType: string;
    number: ValueFormHealth;
    portalValue: ValueFormHealth;
    stairsValue: ValueFormHealth;
    floorValue: ValueFormHealth;
    doorValue: ValueFormHealth;
    postalCode: ValueFormHealthAddress;
    town: ValueFormHealthAddress;
    province: ValueFormHealthAddress;
    provinceLabel: string;
    socialReason: ValueFormHealth;
    responsable: ValueFormHealth;
    sameAsTaker: boolean;
    normalizaDireciones: "N" | "S";
    country: ValueFormHealthAddress;
}

interface AddressDefaultData {
    defaultCountry?: DefaultData;
}

export const DefaultAddressDataDto = (defaultData?: AddressDefaultData): AddressDataDto => {
    return {
        address: DefaultValueFormHealthAddress(true),
        wayType: '',
        number: DefaultValueFormHealth(false),
        portalValue: DefaultValueFormHealth(false),
        stairsValue: DefaultValueFormHealth(false),
        floorValue: DefaultValueFormHealth(false),
        doorValue: DefaultValueFormHealth(false),
        postalCode: DefaultValueFormHealthAddress(true),
        town: DefaultValueFormHealthAddress(true),
        province: DefaultValueFormHealthAddress(false),
        provinceLabel: '',
        socialReason: DefaultValueFormHealth(false),
        responsable: DefaultValueFormHealth(false),
        sameAsTaker: false,
        normalizaDireciones: "S",
        country: DefaultValueFormHealthAddress(false, defaultData && defaultData.defaultCountry),
    };
}
